module.exports = __webpack_public_path__ + "media/fonts/alternate-gothic-no3-regular-webfont-23bb7caf6e39bf4673a483857329d6b6.woff2";